import { render } from "./Home.vue?vue&type=template&id=501e8a3d&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=501e8a3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501e8a3d"]])

export default __exports__